import React from 'react';
import { NextPage } from 'next';
import { Hero, SEO } from 'templates/layout';
import { CONTACT_US_ROUTE } from 'data/routes';
import { quoteBg } from 'images/quote';
import { SpacingLayout } from 'components/atoms';
import { Box, Typography } from '@material-ui/core';
import { QuoteForm } from 'templates/forms';

const Quote: NextPage = () => {
  return (
    <>
      <SEO
        title={'Get the best quote'}
        description={'Identify the right quote that will work, namely for you - with us, it is easier than ever before.'}
      />

      <Hero
        title={
          <>
            LET'S DO <br />
            <span>BUSINESS</span>
          </>
        }
        buttonText={'Contact Us'}
        text={'Explore the most detailed quotes'}
        image={quoteBg}
        link={CONTACT_US_ROUTE}
      />

      <SpacingLayout>
        <Box data-aos="fade-up">
          <Typography align="center" variant="h2" component="h2">
            <span>PICK A LOAD TYPE</span>
          </Typography>
        </Box>
        <Box mb={6} />
        <QuoteForm />
      </SpacingLayout>
    </>
  );
};

export default Quote;
